import { MenuItem } from "@mui/material";

import { IRules, IRulesInvoicing, InvoicingType, PaymentMethodType, ChargeType } from "../../SetupLife.types";
import { Container, Row, SelectForm, TextField } from "./Rules.styled";
import { maskPercentage } from "./Rules.utils";

interface IProps {
  rules: IRules;
  handleChange: (payload: Partial<IRules>) => void;
}

export function RulesTabInvoicing({ rules, handleChange }: IProps) {
  /** Função responsável especificamente por receber os valores alterados e formatar corretamente para handleChange. */
  function handleChangeInvoicing(payload: Partial<IRulesInvoicing>) {
    const updatedInvoicingFields = { ...rules.rulesInvoicing, ...payload };

    handleChange({ ...rules, rulesInvoicing: updatedInvoicingFields });
  }

  return (
    <Container>
      <Row>
        <SelectForm
          label="Tipo da fatura"
          value={rules.rulesInvoicing.invoicingType}
          onChange={(e) => handleChangeInvoicing({ invoicingType: e.target.value as InvoicingType })}
        >
          <MenuItem value={"TAXA_CAPITAL_SEGURADO"}>Taxa sobre Capital Segurado</MenuItem>
        </SelectForm>
        <TextField
          label="Valor do Produto c/ IOF"
          value={maskPercentage(rules.rulesInvoicing.productValueIof)}
          onChange={(e) => handleChangeInvoicing({ productValueIof: e.target.value })}
        />
        <SelectForm
          label="Forma de pagamento"
          value={rules.rulesInvoicing.paymentMethod}
          onChange={(e) => handleChangeInvoicing({ paymentMethod: e.target.value as PaymentMethodType })}
        >
          <MenuItem value={"BOLETO"}>Boleto</MenuItem>
        </SelectForm>
        <SelectForm
          label="Tipo de cobrança"
          value={rules.rulesInvoicing.chargeType}
          onChange={(e) => handleChangeInvoicing({ chargeType: e.target.value as ChargeType })}
        >
          <MenuItem value={"PRO_RATA"}>Pro-rata</MenuItem>
          <MenuItem value={"MES_CHEIO"}>Mes cheio</MenuItem>
        </SelectForm>
      </Row>
    </Container>
  );
}
